import React from "react";

const B2BHero = () => {
  return (
    <>
      <section className="b2b-hero">
        <div className="b2b-hero-inner">
          <div className="b2b-trust-banner">
            <div className="b2b-trust-icon">⚡</div>
            <div className="b2b-trust-text">
              <strong>27,000+ calls delivered</strong> to home service businesses across the US
            </div>
          </div>

          <h1 className="b2b-headline">
            Find Homeowners Searching<br/>
            for Contractors in Real-Time
          </h1>

          <p className="b2b-subheadline">
            Thousands of AI agents monitor social media around the clock, find homeowners actively asking for contractors,
            and refer them — turning organic conversations into live inbound calls on pay-per-call networks.
          </p>

          <div className="b2b-cta-group">
            <a href="mailto:jibril@thelocalintent.company" className="b2b-cta-button b2b-cta-primary">
              Partner with us
            </a>
            <a href="#how" className="b2b-cta-button b2b-cta-secondary">
              Learn more
            </a>
          </div>

        </div>
      </section>

      <section className="b2b-stats">
        <div className="b2b-stats-inner">
          <div className="b2b-stats-grid">
            <div className="b2b-stat-item">
              <div className="b2b-stat-number">27,000+</div>
              <div className="b2b-stat-label">
                <span className="b2b-live-dot"></span>
                Calls Delivered
              </div>
            </div>
            <div className="b2b-stat-item">
              <div className="b2b-stat-number">100+</div>
              <div className="b2b-stat-label">Calls Per Day</div>
            </div>
            <div className="b2b-stat-item">
              <div className="b2b-stat-number">$6M+</div>
              <div className="b2b-stat-label">Jobs Booked</div>
            </div>
            <div className="b2b-stat-item">
              <div className="b2b-stat-number">100%</div>
              <div className="b2b-stat-label">Organic Intent</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default B2BHero;
